/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
import promo1 from "assets/img/theme/pic.PNG";
import promo2 from "assets/img/theme/fit.PNG";
import promo3 from "assets/img/theme/promo 3.PNG";
import promo4 from "assets/img/theme/promo 4.PNG";
import cardImg from "assets/img/theme/TNGRRLUMA-U024NGNS9N2-a14fc31b9b1c-512.jpg";
import ill2 from "assets/img/ill/ill-2.svg";
import team1 from "assets/img/theme/team-1-800x800.jpg";
import team2 from "assets/img/theme/team-2-800x800.jpg";
import team3 from "assets/img/theme/team-3-800x800.jpg";
import team4 from "assets/img/theme/team-4-800x800.jpg";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

// index page sections
import Download from "../IndexSections/Download.js";

class Landing extends React.Component {
  state = {};
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-primary">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="6">
                      <h1 className="display-3 text-white">
                        Rami Zaitoun{" "}
                        <span>Software Developer</span>
                      </h1>
                      <p className="lead text-white">
                        I have accomplished 6-months Full-Stack development course with ASAC powerd by Code Fellows <img src = "https://secure.meetupstatic.com/photos/event/7/5/f/7/600_454410199.jpeg" width ="120" height="40"></img>
                      </p>
                      <p className="lead text-white">
                        As a software developer,I've worked on multiple projects  and I'm eager to continue this challenging journey.

                      </p>

                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                  <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                            <i className="ni ni-book-bookmark" />
                          </div>
                          <h6 className="text-warning text-uppercase">
                            Last Chapter
                          </h6>
                          <p className="description mt-3">
                          A simple React app where you can find your favourite books,Share Your feedback,And find out community reviews
                          </p>
                          <div>
                            <Badge color="warning" pill className="mr-1">
                              HTML
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              CSS
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              Javascript
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              React JS
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              Node JS
                            </Badge>
                          </div>
                          <Button
                            className="mt-4"
                            color="warning  "
                            href="https://lastchapter.netlify.app"

                          >
                            Link
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          
                          <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                            <i className="ni ni-map-big" />
                          </div>
                          <h6 className="text-primary text-uppercase">
                            cookie-stand
                          </h6>
                          <p className="description mt-3">
                            Basic website that calculates daily sales projections for each location on a page called sales
                            that is colorful, eye-catching, readable, useful, and informative.

                          </p>
                          <div>

                            <Badge color="primary" pill className="mr-1">
                              HTML
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              CSS
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              JavaScript
                            </Badge>
                          </div>
                          <Button
                            className="mt-4"
                            color="primary"
                            href="https://mastermind6666.github.io/cookie-stand/"

                          >
                            Link
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                            <i className="ni ni-basket" />
                          </div>
                          <h6 className="text-success text-uppercase">
                            Fitness Guide
                          </h6>
                          <p className="description mt-3">
                            Fitness-Guide is a website where you can select your sport and buy it's items.
                            i Worked closely with programmers to meet project requirements, goals.
                          </p>
                          <div>
                            <Badge color="success" pill className="mr-1">
                              HTML
                            </Badge>
                            <Badge color="success" pill className="mr-1">
                              CSS
                            </Badge>
                            <Badge color="success" pill className="mr-1">
                              Javascript
                            </Badge>
                          </div>
                          <Button
                            className="mt-4"
                            color="success"
                            href="https://mastermind6666.github.io/Fitness/"

                          >
                            Link
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                   
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-danger rounded-circle mb-4">
                            <i className="ni ni-bus-front-12" />
                          </div>
                          <h6 className="text-danger text-uppercase">
                            Bus-mall
                          </h6>
                          <p className="description mt-3">
                            this project  about choosing a random product after that the product has the most views  will be seen in a chart
                          </p>
                          <div>
                            <Badge color="danger" pill className="mr-1">
                              HTML
                            </Badge>
                            <Badge color="danger" pill className="mr-1">
                              CSS
                            </Badge>
                            <Badge color="danger" pill className="mr-1">
                              Javascript
                            </Badge>
                          </div>
                          <Button
                            className="mt-4"
                            color="danger"
                            href="https://mastermind6666.github.io/bus-mall/"

                          >
                            Link
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                            <i className="ni ni-zoom-split-in" />
                          </div>
                          <h6 className="text-primary text-uppercase">
                          City Explorer
                          </h6>
                          <p className="description mt-3">
                          takes any city and gives you the location of it and the top reated movies using locationiq Api to get the location of any city or country you want

                          </p>
                          <div>
                            <Badge color="primary" pill className="mr-1">
                            HTML
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                            CSS
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                            Sass
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                            Javascript
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                            React
                            </Badge>
                          </div>
                          <Button
                            className="mt-4"
                            color="primary"
                            href="https://mapexplore.netlify.app"

                          >
                            Link
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                            <i className="ni ni-curved-next" />
                          </div>
                          <h6 className="text-warning text-uppercase">
                            future project
                          </h6>
                          <p className="description mt-3">
                            Future project will be added here!
                          </p>
                          <div>
                            <Badge color="warning" pill className="mr-1">
                              Future
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              Future
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              Future
                            </Badge>
                          </div>
                          <Button
                            className="mt-4"
                            color="warning"
                            href="https://advertisermirror.com/wp-content/uploads/2021/02/Page-Not-Found-Error-404.png"

                          >
                            Link
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid floating"
                    src={promo1}
                  />
                  <img
                    alt="..."
                    className="img-fluid floating"
                    src={promo2}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings-gear-65" />
                    </div>
                    <h3>Fitness Guide Feature</h3>
                    <p>
                    Fitness-Guide is a website where you can select your sport and buy it's items.
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="warning"
                            >
                              <i className="ni ni-settings-gear-65" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Calories Calculator
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="warning"
                            >
                              <i className="ni ni-user-run" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">Sports Guide</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="warning"
                            >
                              <i className="ni ni-satisfied" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Easy to Use
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
                
              </Row>
            </Container>
          </section>
          <section className="section section-lg">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid floating"
                    src={promo3}
                  />
                  <img
                    alt="..."
                    className="img-fluid floating"
                    src={promo4}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-danger shadow rounded-circle mb-5">
                      <i className="ni ni-settings-gear-65" />
                    </div>
                    <h3>Last Chapter</h3>
                    <p>
                     LastChapter is a simple React app where you can find your favourite books, Share Your feedback, And find out community reviews
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="danger"
                            >
                              <i className="ni ni-books" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Book Categories
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="danger"
                            >
                              <i className="ni ni-active-40" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">Community Reviews</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="danger"
                            >
                              <i className="ni ni-satisfied" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Easy to Use
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
                
              </Row>
            </Container>
          </section>
          <section className="section bg-secondary">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="..."
                      src={cardImg}
                      top
                    />
                    <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Rami Zaitoun
                      </h4>
                      <p className="lead text-italic text-white">
                      A web developer with over one year experience in Software Development 
                        mainly,Front-End passion for responsive website design
                         
                        ,Skilled in designing,
                        Developing multiple web-based applications
                        incorporating a range of technologies, Aspiring to
                        combine broad background with strong technical
                        skills to excel, Certified by  <img src = "https://secure.meetupstatic.com/photos/event/7/5/f/7/600_454410199.jpeg" width ="80" height="30"></img>


                      </p>
                    </blockquote>
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-primary shadow rounded-circle mb-5">
                      <i className="ni ni-single-02" />
                    </div>
                    <h3>Background</h3>
                    <p className="lead">
                      Hi, I'm rami, 24 year old graduated student with a major in computer science. 

                    </p>
                    <p>
                      two years ago I was learning to code,I was frustrated about my lack of clarity about where to go and whom to learn from,
                      With overwhelming career choices within tech and ever changing programming languages and frameworks,
                      the first few months were hard for me.
                    </p>
                    <p>
                       So one year ago I decided to focus on learnning web development
                      I've completed <br></br><strong>6-months course with ASAC powered by code fellows</strong> as a Full-Stack developer

                     ,I've worked on multiple projects and I eager to continue this challngeing journey.
          

                    </p>
                    <a
                      className="font-weight-bold text-warning mt-5"
                      href="https://ramizaitoun.netlify.app"

                    >
                      See More
                    </a>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>


          <Download />
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default Landing;
